export const IdXboxIntroFormId = "id-xbox-intro";

export enum IdXboxIntroSubFormsId {
  ContactInformation = "contact",
  StudioInformation = "studio",
}

export const IdXboxIntroSubFormsIdsOrder = [
  IdXboxIntroSubFormsId.ContactInformation,
  IdXboxIntroSubFormsId.StudioInformation,
];

export const IdXboxIntroSubFormsLocalizedStringIds: { [subForm: string]: string } = {
  ["formTitle"]: "introFormsTitle",
  ["formSubtitle"]: "",
  [IdXboxIntroSubFormsId.ContactInformation]: "introContactInformationTitle",
  [IdXboxIntroSubFormsId.StudioInformation]: "introStudioInformationTitle",
};
